import { EventBus } from '../../helpers';

type ThankYouEvents = {
  mainButtonClicked: [];
  cardButtonClicked: [];
  xeroPartnerButtonClicked: [];
  resendVerificationClicked: [];
  registerSmsClicked: [];
  verificationEmailSent: [emailAddress: string];
  verificationEmailFailed: [];
};

class ThankYouEventBus extends EventBus<ThankYouEvents> {}

export const thankYouEventBus = new ThankYouEventBus();
